import { axios } from 'shared';

import { SearchLocation } from './types';

export function getSearchLocation({ guid }: { guid: string }) {
  return axios.get<SearchLocation>(`/v1/locations/${guid}`);
}
